import { Category, Option } from '../../../../../types';

export const toOptions = (data: Category[]): Option<string>[] =>
  data.map(({ title, value, meta }) => ({ label: title, value, meta }));
